import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import {
  FaMapMarkerAlt,
  FaShareAlt,
} from "react-icons/fa";

export default function LocalUpdates() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNews();
  }, []);

  const loadNews = async () => {
    try {
      const q = query(
        collection(db, "localNews"),
        orderBy("createdAt", "desc")
      );

      const snap = await getDocs(q);

      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setNews(data);
    } catch (err) {
      console.error("Error loading local news:", err);
    }

    setLoading(false);
  };

  // =========================================================
  // SHARE TO WHATSAPP
  // =========================================================
  const handleShare = (item) => {
    const articleUrl = item.newsUrl || "";
    const title = item.text || "Local Update";

    const shareText = `Local Update - 

${title}

https://eyalmart.com/localupdates`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      shareText
    )}`;

    window.open(
      whatsappUrl,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div style={styles.page}>

      {/* =====================================================
          HEADER
      ====================================================== */}
      <div style={styles.header}>

        <div style={styles.title}>
          <FaMapMarkerAlt />
          Local Updates
        </div>

        <div style={styles.count}>
          {news.length}
        </div>

      </div>


      {/* =====================================================
          LOADING
      ====================================================== */}
      {loading && (
        <div style={styles.loading}>
          Loading...
        </div>
      )}


      {/* =====================================================
          EMPTY
      ====================================================== */}
      {!loading && news.length === 0 && (
        <div style={styles.empty}>
          No updates available.
        </div>
      )}


      {/* =====================================================
          NEWS LIST
      ====================================================== */}
      {news.map((item) => (

        <div
          key={item.id}
          style={styles.card}
        >

          {/* =================================================
              IMAGE
          ================================================== */}
          {item.imgUrl && (
            <img
              src={item.imgUrl}
              alt=""
              style={styles.image}
            />
          )}


          <div style={styles.content}>

            {/* ===============================================
                AREA
            ================================================ */}
            <div style={styles.badge}>
              {item.area}
            </div>


            {/* ===============================================
                NEWS TITLE
            ================================================ */}
            <div style={styles.newsTitle}>
              {item.text}
            </div>


            {/* ===============================================
                FOOTER
            ================================================ */}
            <div style={styles.footer}>

              {/* DATE / TIME */}
              <small style={styles.time}>
                {item.createdAt?.toDate
                  ? item.createdAt
                      .toDate()
                      .toLocaleString("en-IN")
                  : ""}
              </small>


              {/* =============================================
                  ACTION BUTTONS
              ============================================== */}
              {item.newsUrl && (
                <div style={styles.actionButtons}>

                  {/* SHARE */}
                  <button
                    type="button"
                    style={styles.shareButton}
                    onClick={() => handleShare(item)}
                  >
                    <FaShareAlt size={14} />
                    Share
                  </button>


                  {/* READ MORE */}
                  <button
                    type="button"
                    style={styles.button}
                    onClick={() =>
                      window.open(
                        item.newsUrl,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    Read More →
                  </button>

                </div>
              )}

            </div>

          </div>

        </div>

      ))}

    </div>
  );
}


/* ============================================================
   STYLES
============================================================ */

const styles = {

  /* ==========================================================
     PAGE
  ========================================================== */

  page: {
    maxWidth: 700,
    margin: "0 auto",
    padding: "75px 14px 90px",
    background: "#f5f7fb",
    minHeight: "100vh",
    boxSizing: "border-box",
  },


  /* ==========================================================
     HEADER
  ========================================================== */

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 18,
  },


  title: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: "#2563eb",
    fontSize: 24,
    fontWeight: 700,
  },


  count: {
    background: "#2563eb",
    color: "#fff",
    borderRadius: 20,
    padding: "5px 12px",
    fontSize: 13,
    fontWeight: 700,
  },


  /* ==========================================================
     LOADING
  ========================================================== */

  loading: {
    textAlign: "center",
    padding: 40,
    color: "#6b7280",
  },


  /* ==========================================================
     EMPTY
  ========================================================== */

  empty: {
    background: "#fff",
    borderRadius: 16,
    padding: 50,
    textAlign: "center",
    color: "#6b7280",
  },


  /* ==========================================================
     NEWS CARD
  ========================================================== */

  card: {
    background: "#fff",
    borderRadius: 18,
    overflow: "hidden",
    marginBottom: 20,
    boxShadow: "0 4px 15px rgba(0,0,0,.08)",
  },


  /* ==========================================================
     IMAGE
  ========================================================== */

  image: {
    width: "100%",
    height: 220,
    objectFit: "cover",
    display: "block",
  },


  /* ==========================================================
     CONTENT
  ========================================================== */

  content: {
    padding: 16,
  },


  /* ==========================================================
     AREA BADGE
  ========================================================== */

  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "#eef4ff",
    color: "#2563eb",
    padding: "6px 12px",
    borderRadius: 20,
    fontWeight: 600,
    fontSize: 12,
    marginBottom: 12,
  },


  /* ==========================================================
     NEWS TITLE
  ========================================================== */

  newsTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1.5,
    marginBottom: 18,
  },


  /* ==========================================================
     FOOTER
  ========================================================== */

  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #f1f5f9",
    paddingTop: 14,
    gap: 10,
  },


  /* ==========================================================
     TIME
  ========================================================== */

  time: {
    color: "#6b7280",
    fontSize: 13,
    lineHeight: 1.3,
  },


  /* ==========================================================
     ACTION BUTTONS
  ========================================================== */

  actionButtons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: 8,
    flexShrink: 0,
  },


  /* ==========================================================
     SHARE BUTTON
  ========================================================== */

  shareButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    background: "#eef4ff",
    color: "#2563eb",
    border: "none",
    borderRadius: 10,
    padding: "10px 12px",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },


  /* ==========================================================
     READ MORE BUTTON
  ========================================================== */

  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "10px 18px",
    fontWeight: 600,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },


  /* ==========================================================
     UNUSED / FUTURE
  ========================================================== */

  area: {
    fontSize: 18,
    fontWeight: 400,
    color: "#374151",
    marginBottom: 8,
  },

  description: {
    color: "#4b5563",
    lineHeight: 1.7,
    fontSize: 15,
    marginBottom: 18,
  },
};